import { combineReducers, configureStore } from '@reduxjs/toolkit';
import aoiReducer from './aoiSlice/aoiSlice';
import drawReducer from './drawSlice/drawSlice';
import alertReducer from './alertSlice/alertSlice';
import supplementaryReducer from './SupplimentaryDataSlice/supplementaryDataSlice';
import mapReducer from './mapSlice/mapSlice';
import assetsReducer from './assetsSlice/assetsSlice';
import mapConfigReducer from './mapConfigSlice/mapConfigSlice';
import mapViewReducer from './mapViewSlice/mapViewSlice';
import layersReducer from './layersSlice/layersSlice';
import enquiryReducer from './enquirySlice/enquirySlice';
import enquiryRequestReducer from './enquiryRequestSlice/enquiryRequestSlice';
import workpackReducer from './workpackSlice/workpackSlice';
import assetOwnersSlice from 'client/store/assetOwnersSlice/assetOwnersSlice';
import localeSlice from 'client/store/localeSlice/localeSlice';
import coverageAssetOwnersSlice from 'client/store/coverageAssetOwnersSlice/coverageAssetOwnersSlice.js';
import systemMessagesReducer from 'client/store/systemMessageSlice/systemMessageSlice';
import isolatedViewsReducer from 'client/store/isolatedViewsSlice/isolatedViewsSlice';

import { devToolsEnhancer } from '@redux-devtools/extension';

export const reducer = combineReducers({
    aoi: aoiReducer,
    draw: drawReducer,
    alert: alertReducer,
    supplementaryData: supplementaryReducer,
    map: mapReducer,
    isolatedViews: isolatedViewsReducer,
    assets: assetsReducer,
    mapConfig: mapConfigReducer,
    mapView: mapViewReducer,
    layers: layersReducer,
    enquiries: enquiryReducer,
    enquiriesRequest: enquiryRequestReducer,
    workpacks: workpackReducer,
    assetOwners: assetOwnersSlice,
    locale: localeSlice,
    coverageAssetOwners: coverageAssetOwnersSlice,
    systemMessages: systemMessagesReducer
});

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => (isDevelopment || isTest) ? getDefaultMiddleware({ serializableCheck: false }) : getDefaultMiddleware(),
    devTools: isDevelopment ? [devToolsEnhancer({ realtime: true })] : false
});

export default store;
